export default __webpack_public_path__ + "static/media/product_img.b853fd9c.svg";